<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">
        Relatórios
        <br />
        <small>Ranking de lançamentos de dados {{ anoAnterior }}</small>
      </h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable1"
            :show-empty="true"
            title="Secretarias"
            api-url="dado/secretaria/rankinglancamentos"
            report-title="Ranking de lançamentos de dados 2018 por secretarias"
            :initial-page="paginaSecretarias"
            :pageCollection="'dadosRelatoriosSecretarias'"
            :fields="fields1"
          >
          </list>
        </div>

        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable2"
            :show-empty="true"
            title="Autarquias"
            api-url="dado/autarquia/rankinglancamentos"
            report-title="Ranking de lançamentos de dados 2018 por secretarias"
            :initial-page="paginaAutarquias"
            :pageCollection="'dadosRelatoriosAutarquias'"
            :fields="fields2"
          >
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from '@/components/common/DataTable'

export default {
  name: 'relatorio',
  data() {
    return {
      fields1: [
        {
          name: 'sigla',
          title: 'Sigla',
          dataClass: 'align-middle'
        },
        {
          name: 'nome',
          title: 'Nome',
          dataClass: 'align-middle'
        },
        {
          name: 'total_dados',
          title: 'Total de dados',
          dataClass: 'da-align-center'
        },
        {
          name: 'total_lancado',
          title: 'Dados lançados',
          dataClass: 'da-align-center'
        },
        {
          name: 'total_concluido',
          title: '% Concluido',
          dataClass: 'da-align-center'
        }
      ],
      fields2: [
        {
          name: 'sigla',
          title: 'Sigla',
          dataClass: 'align-middle'
        },
        {
          name: 'nome',
          title: 'Nome',
          dataClass: 'align-middle'
        },
        {
          name: 'total_dados',
          title: 'Total de dados',
          dataClass: 'da-align-center'
        },
        {
          name: 'total_lancado',
          title: 'Dados lançados',
          dataClass: 'da-align-center'
        },
        {
          name: 'total_concluido',
          title: '% Concluido',
          dataClass: 'da-align-center'
        }
      ],
      timer: ''
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    const atualiza = () => {
      this.$refs.vuetable1.refresh()
      this.$refs.vuetable2.refresh()
    }

    this.timer = setInterval(atualiza, 60000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  computed: {
    anoAnterior() {
      return new Date().getFullYear() - 1
    },
    paginaSecretarias: {
      get() {
        const { dadosRelatoriosSecretarias } = this.$store.state.vuetableState
        const { paginaSecretarias } = dadosRelatoriosSecretarias
        return paginaSecretarias
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dadosRelatoriosSecretarias',
          value: value
        })
      }
    },
    paginaAutarquias: {
      get() {
        const { dadosRelatoriosAutarquias } = this.$store.state.vuetableState
        const { paginaAutarquias } = dadosRelatoriosAutarquias
        return paginaAutarquias
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dadosRelatoriosAutarquias',
          value: value
        })
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/relatorio/index.vue